import { getRequest } from '../utils'

export interface CharacteristicSupportReactionRow {
  load_case_label: string
  forces_newton: number[]
  /** Range over the full loading and the field-wise arrangements of the decisive
   * positioning; `null`/missing when the load case is not positioned. */
  forces_min_newton?: number[] | null
  forces_max_newton?: number[] | null
  /** Fields of the positioned load case and, per support, the loaded fields of the
   * arrangement giving the min/max reaction. */
  positioned_fields?: string[] | null
  forces_min_loaded_fields?: string[][] | null
  forces_max_loaded_fields?: string[][] | null
}

export interface CharacteristicMemberSupportReactions {
  element_guid: string
  support_names: string[]
  rows: CharacteristicSupportReactionRow[]
}

/** One request for all members. */
export const getAllCharacteristicMemberSupportReactions = {
  getKey: (projectId: string) => ['characteristicMemberSupportReactions', projectId] as const,
  request: async (
    projectId: string,
    signal?: AbortSignal,
  ): Promise<CharacteristicMemberSupportReactions[] | null> => {
    const { data } = await getRequest<CharacteristicMemberSupportReactions[]>({
      url: `/projects/${projectId}/characteristic-member-support-reactions`,
      ...(signal ? { signal } : {}),
    })

    return data
  },
}
